import { takeEvery } from 'redux-saga'
import { put, call, fork } from 'redux-saga/effects'
import * as SignUpAPI from 'api/signup.api.js';



export function* SubmitEmail(action) {
  yield SignUpAPI.SubmitEmail(action.email, action.name)
}

export function* SubmitEmailFlow() {
  yield takeEvery('SUBMIT_EMAIL', SubmitEmail);
}

export function* SendPayment(action) {
  const confirmation = yield call(SignUpAPI.SendPayment, action.token);
  yield put({type: 'CONFIRM_PAYMENT', data: {confirmation} });
}

export function* SendPaymentFlow() {
  yield takeEvery('SEND_PAYMENT', SendPayment);
}

export function* ConfirmPayment(action) {
}

export function* ConfirmPaymentFlow() {
  yield takeEvery('CONFIRM_PAYMENT', ConfirmPayment);
}

export function* AthleteUseAccessCode(action) {
  const { accessCode, profile } = action;
  const athleteAccessResponse = yield call(SignUpAPI.AthleteUseAccessCode, accessCode, profile);
  yield put({type:'SET_ATHLETE_ACCESS_RESP', athleteAccessResponse });
}

export function* AthleteUseAccessCodeFlow() {
  yield takeEvery('ATHLETE_USE_ACCESS_CODE', AthleteUseAccessCode);
}

export function* BoxPay(action) {
  const { token } = action;
  const accessUrl = yield call(SignUpAPI.BoxPay, token);
  yield put({type:'SHARE_GYM_OWNER_ACCESS_URL', accessUrl });
}

export function* BoxPayFlow() {
  yield takeEvery('BOX_PAY', BoxPay);
}

export function* DHRCoachPay(action) {
  const { token } = action;
  const accessUrl = yield call(SignUpAPI.DHRCoachPay, token);
  yield put({type:'SHARE_GYM_OWNER_ACCESS_URL', accessUrl });
}

export function* DHRCoachPayFlow() {
  yield takeEvery('DHR_COACH_PAY', DHRCoachPay);
}

export function* InitUserAcct(action) {
  const { data } = action;
  yield call(SignUpAPI.InitUserAcct, data);
}

export function* InitUserAcctFlow() {
  yield takeEvery('INIT_USER_ACCT', InitUserAcct);
}

export default function* signUp(getStore) {
  yield [
    fork(SubmitEmailFlow),
    fork(SendPaymentFlow),
    fork(ConfirmPaymentFlow),
    fork(AthleteUseAccessCodeFlow),
    fork(BoxPayFlow),
    fork(DHRCoachPayFlow),
    fork(InitUserAcctFlow),
  ];
}




// WEBPACK FOOTER //
// ./src/sagas/SignUpSaga.js